// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2lWd7","inner":"Footer_inner__zWpcD"};